// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d116fd44","726":"aa52c194"}[chunkId] + ".chunk.js";
};